import {
  ENQUIRY_MANAGEMENT_DETAILS,
  ENQUIRY_MANAGEMENT_DETAILS_SUCCESS,
  ENQUIRY_MANAGEMENT_DETAILS_FAIL,
  ENQUIRY_MANAGEMENT_CSV_START,
  ENQUIRY_MANAGEMENT_CSV_SUCCESS,
  ENQUIRY_MANAGEMENT_CSV_ERROR,
} from "../Constants/EnquiryManagementConstant";

const initialState = {
  enquiryDataLoading: false,
  enquiryData: [],
  csvLoading: false,
};

export default function enquiryManagementReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case ENQUIRY_MANAGEMENT_DETAILS:
      return {
        ...state,
        enquiryDataLoading: true,
      };
    case ENQUIRY_MANAGEMENT_DETAILS_SUCCESS:
      return {
        ...state,
        enquiryDataLoading: false,
        enquiryData: action.payload,
      };
    case ENQUIRY_MANAGEMENT_DETAILS_FAIL:
      return {
        ...state,
        enquiryDataLoading: false,
        enquiryData: [],
      };
    case ENQUIRY_MANAGEMENT_CSV_START:
      return {
        ...state,
        csvLoading: true,
      };
    case ENQUIRY_MANAGEMENT_CSV_SUCCESS:
      return {
        ...state,
        csvLoading: false,
      };
    case ENQUIRY_MANAGEMENT_CSV_ERROR:
      return {
        ...state,
        csvLoading: false,
      };

    default:
      return state;
  }
}
